import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const binoculars: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5.5-9.5v6a.5.5 0 0 1-.156.36A.47.47 0 0 1 5-3v4.5c0 .133-.055.25-.156.344A.46.46 0 0 1 4.5 2h-4a.5.5 0 0 1-.36-.156A.47.47 0 0 1 0 1.5v-4l1.953-6.828q.047-.17.235-.172zm2.5 0V-4H6v-5.5Zm6 7v4c0 .133-.055.25-.156.344A.46.46 0 0 1 13.5 2h-4a.5.5 0 0 1-.36-.156A.47.47 0 0 1 9 1.5V-3a.52.52 0 0 1-.36-.14.52.52 0 0 1-.14-.36v-6h3.313q.187.001.25.172zm-8.25-9.25V-10H3v-1.75q0-.106.063-.172A.26.26 0 0 1 3.25-12H5.5q.106 0 .172.078.077.066.078.172m5.25 0V-10H8.25v-1.75q0-.106.063-.172A.26.26 0 0 1 8.5-12h2.25q.106 0 .172.078.076.066.078.172m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "14",
  }
}